import React from "react";
import { Page, NavItem, TabPane } from "components/common";
import { compose } from "recompose";
import { Nav, TabContent } from "reactstrap";
import Table from "./Table";
import { Trans } from "react-i18next";
import { Link, Switch, Redirect } from "react-router-dom";

const getTable = (Status) => (props) =>
  (
    <Table
      filters={{
        extra_params: {
          Status,
        },
      }}
      status={Status}
      {...props}
    />
  );

const All = getTable();
const Draft = getTable("DRAFT");
const AwaitingApproval = getTable("SUBMITTED");
const Approved = getTable("AUTHORISED");
const Billed = getTable("BILLED");

export const List = ({ match }) => (
  <Page title="Purchase Orders">
    <div>
      <div>
        <Link to={`${match.url}/edit/new`} className="btn btn-primary mb-2">
          <span className="fa fa-plus" />
          <span className="mx-1" />
          <Trans>New Purchase Order</Trans>
        </Link>
      </div>
      <Nav tabs>
        <NavItem to={`${match.url}/all`}>All</NavItem>
        <NavItem to={`${match.url}/draft`}>Draft</NavItem>
        <NavItem to={`${match.url}/awaiting_approval`}>
          Awaiting Approval
        </NavItem>
        <NavItem to={`${match.url}/approved`}>Approved</NavItem>
        <NavItem to={`${match.url}/billed`}>Billed</NavItem>
      </Nav>
      <TabContent>
        <Switch>
          <TabPane path={`${match.url}/all`} component={All} />
          <TabPane path={`${match.url}/draft`} component={Draft} />
          <TabPane
            path={`${match.url}/awaiting_approval`}
            component={AwaitingApproval}
          />
          <TabPane path={`${match.url}/approved`} component={Approved} />
          <TabPane path={`${match.url}/billed`} component={Billed} />
          <Redirect to={`${match.url}/all`} />
        </Switch>
      </TabContent>
    </div>
  </Page>
);

export const enhance = compose();

export default enhance(List);
